export const MODEL_TITLE = [
  "Stéphane",
  "Aurelia",
  "Elektra",
  "Turing"
]

export const REAL_MODEL_NAME = [
  "https://ia-generative.giris.fr:8445/stephane",
  "https://models.giris.fr:8444/aurelia",
  "https://models.giris.fr:8444/aurelia",
  "https://models.giris.fr:8444/aurelia",
]

export const GEMINI_URL = "https://models.giris.fr:8444/gemini"

export const REAL_MODEL_NAME2 = "https://models.giris.fr:8444/v2/aurelia"

export const PYTHON_API_URL = [
"https://ia-generative.giris.fr:8445",
"https://models.giris.fr:8444",
"https://models.giris.fr:8444",
"https://models.giris.fr:8444",
]

export const MODEL_DESCRIPTION = [
"INGENIEUR AVANT-VENTE",
"EMAIL SALES SPECIALIST",
"DATA SPECIALIST",
"DEVOPS & CYBERSECURITY SPECIALIST",
]

export const MESSAGE = [
  "Votre demande est en cours de traitement. Les détails vous seront envoyés par e-mail, pensez à vérifier votre boîte de réception.",
  "Traitement en cours. Vous recevrez un e-mail à l'adresse indiquée dans les prochaines minutes.",
  "Le processus suit son cours. Un e-mail vous sera envoyé sous peu à l'adresse que vous avez fournie.",
  "Merci pour votre patience. Vous recevrez les informations par e-mail d’ici quelques instants.",
  "Nous finalisons le processus. Un e-mail contenant les détails vous sera transmis à l'adresse que vous avez saisie.",
  "C’est presque terminé ! Vérifiez votre e-mail dans quelques minutes pour obtenir les informations.",
  "Un e-mail contenant les informations nécessaires vous sera envoyé sous peu. Merci de vérifier votre boîte de réception.",
  "Les informations seront transmises par e-mail à l’adresse que vous avez mentionnée. Veuillez surveiller votre boîte de réception.",
  "Votre demande est en cours. Un e-mail de confirmation vous sera envoyé dans les prochaines minutes.",
  "Le traitement est en cours. Merci de consulter l’e-mail que vous avez indiqué pour les prochaines étapes.",
]


export const MAIL_FORMAT_DATA = [
  {
    title: "Format du mail",
    content: [
      "Métaphore",
      "Réponse à choix multiple",
      "Question ouverte",
      "Étude de cas / Succès client",
      "Offre de contenu gratuit",
      "Invitation à un événement",
      "Quiz personnalisé",
      "Comparaison avant/après",
      "Format contextuel",
      "Défi de 7 jours",
      "Technologies",
      "Healthtech (english)",
      // ""
    ]
  }
]

export const MAIL_TITLE_AND_STATE = [
  {
    title: "Métaphore",
    status: false
  },
  {
    title: "Réponse à choix multiple",
    status: false
  },
  {
    title: "Question ouverte",
    status: false
  },
  {
    title: "Étude de cas / Succès client",
    status: false
  },
  {
    title: "Offre de contenu gratuit",
    status: false
  },
  {
    title: "Invitation à un événement",
    status: false
  },
  {
    title: "Quiz personnalisé",
    status: false
  },
  {
    title: "Comparaison avant/après",
    status: false
  },
  {
    title: "Format contextuel",
    status: false
  },
  {
    title: "Défi de 7 jours",
    status: false
  },{
    title: "Technologies",
    status: false
  },
  {
    title: "Healthtech",
    status: false
  },
  // {
  //   title: "",
  //   status: false
  // }
]

export const INCITATION_DATA = [
  {
    title: "Incitation à la réponse",
    content: [
        "Question Directe",
        "Choix de Disponibilités",
        "Invitation à l'Action avec Ressource Gratuite"
    ]
}
]

export const AUTRES = [
  {
      title: "Accroche",
      content: [
        "Captivant",
        "Intriguant",
        "Engageant"
      ]
  },
  {
      title: "Paragraphe sur la cible",
      content: [
          "Référence à des réalisations récentes ou à des actualités de l'entreprise",
          "Problèmes ou défis spécifiques à l'industrie",
          "Utilisation de leurs propres mots ou citations",
          "Projets ou initiatives spécifiques de l'entreprise",
          "Données ou statistiques sectorielles pertinentes"
      ]
  },
  {
      title: "Incitation à la réponse",
      content: [
          "Question Directe",
          "Choix de Disponibilités",
          "Invitation à l'Action avec Ressource Gratuite"
      ]
  },
  {
      title: "Titre de mail",
      content: [

      ]
  } 
]

export const MAIL_SEGMENT_KEY_LIST = ["accroche", "transition", "service_value"]

export const NAV_MENU: {[key: string]: string} = {
  "Destinataire" : "Informations sur la cible",
  "Emetteur": "Vos informations",
  "Mail": "Le format de mail",
  "FollowUp" : "Préparer la relance",
  "Config": "",
  "CRM": "Bienvenue sur votre CRM",
  "Configuration": "Configuration du CRM",
  "Recapitulation": "Récapitulation d'informations du CRM",
  "Tarifs": "Bienvenue sur le choix de nos tarifs actuels",
  "Suivi": "Suivez vos campagnes",
  "History" : "",
  "Inspecteur" : "Zone d’évaluation du Prof",
  "Teacher" : "Zone de création de nouvelle catégorie/questions",
  "Stratège" : "Zone de correction du Stratège",
  "Gamification" : "Préparation & progression",
  "EvaluationHistory" : "Historique d'évaluation de l'inspecteur"
}

export const NAV_MENU_TITLE = Object.keys(NAV_MENU)

export const SUB_NAV_MENU_LIST = NAV_MENU_TITLE.splice(0, 5)

export const LANGUAGE_LIST = [
  {name: 'Anglais', classname: "us"},
  {name: 'Portugais', classname: "pt"}
]

export const followUp_template_title = "Relance : [Nom de votre campagne]"
export const followUp_template = [
  `Bonjour {name},

  Vous voyez, même la relance est envoyée toute seule.

  Nos clients constatent une augmentation moyenne de 57% de leur taux de conversion dès le troisième mois (pour ceux ayant un cycle court). {company} peut bénéficier du même taux, voire plus, grâce à une IA qui automatise la prospection avant-vente et envoie des e-mails très personnalisés.

  Toujours pas intéressé pour échanger ? Ou peut-être préférez-vous discuter avec un humain pour découvrir notre méthode secrète ?

  Bien à vous,`,

  `Bonjour {name},

  J'espère que vous passez un excellent été !

  L'IA est une véritable révolution pour booster votre efficacité et optimiser votre emploi du temps. 

  Souhaitez-vous en parler à la rentrée ou discuter de nouveaux sujets passionnants dès maintenant ?

  En attendant votre retour, je vous souhaite d'excellentes vacances et vivez pleinement les Jeux Olympiques.

  Cordialement,`
]

export const LLM_LIST = ["Aurelia", "Elektra", "Turing"]

export const professeur_tutorial_steps = [
  {
    title: 'Plume: étape 1',
    content: "D'abord, cliquez sur le bouton aperçu afin d'afficher les détails du mail",
  },
  {
    title: 'Plume: étape 2',
    content: "Défilez jusqu'à ce que vous voyez le bouton 'configurer' et cliquez dessus.",
  },
]

export const EvaluationRole = ["stratège", "inspecteur"]
export var EvaluatorData: any = {}

EvaluatorData[EvaluationRole[0]] = {
  "title" : EvaluationRole[0].charAt(0).toUpperCase() + EvaluationRole[0].slice(1),
  "btn_title": "Evaluer avec le Stratège",
  "role_desc": "Créer et corriger des mails de façon personnalisé en tant que stratège."
}
EvaluatorData[EvaluationRole[1]] = {
  "title" : EvaluationRole[1].charAt(0).toUpperCase() + EvaluationRole[1].slice(1),
  "btn_title": "Evaluer avec l'Inspecteur",
  "role_desc": "L'inspecteur évalue les mails pour vous en fonction des catégories, sous-catégories et contextes (LinkedIn, posts, etc.) pour améliorer la qualité des mails personnalisés."
}

export const serviceValueQuestions = [
    "Quel a été votre plus grand succès commercial récemment ?",
    "Quelle promesse mettez-vous le plus souvent en avant auprès de vos prospects ?",
    "Comment positionnez-vous votre offre face à la concurrence ?",
    "Y a-t-il un moment marquant dans votre parcours que vous aimez partager ?",
    "Qu’est-ce qui, selon vous, fait vraiment la différence dans votre manière de vendre ?",
    "Quelle partie de votre offre vous rend le plus fier aujourd’hui ?",
    "Quelle expérience passée vous aide à mieux comprendre vos prospects ?",
    "Quelle idée reçue sur votre secteur cherchez-vous souvent à corriger ?",
    "Quel retour client vous a récemment motivé ou marqué ?",
    "Lorsque vous recommandez votre solution, que dites-vous en premier, spontanément ?"
];